import PropTypes from 'prop-types';
import React from 'react';
import Geosuggest from 'react-geosuggest';
const CitySearchCell = ({ props } = {}) => {
    const citySearchCell = ({ value, onValue }) => (React.createElement("div", null,
        React.createElement(Geosuggest, { initialValue: `${value.city}, ${value.state}`, onSuggestSelect: onValue, placeholder: "Enter address...", radius: "20", location: new google.maps.LatLng(53.558572, 9.9278215) })));
    citySearchCell.propTypes = {
        value: PropTypes.object,
        onValue: PropTypes.func,
    };
    return citySearchCell;
};
export default CitySearchCell;
